
import { Vue, Options } from "vue-class-component";

interface Node {
  name: String;
  path: String;
  child: Node[];
}

@Options({
  props: {
    node: Object
  }
})
export default class NavBarRow extends Vue {
  node!: Node;
}
